/**
 * Data 组件 Widget 类（6.2 BaseWidget 体系）
 * Table / Form / List / Pagination / SearchBar / FilterPanel
 *
 * 交互型组件声明 6.3 瞬态（meta）行为钩子：选中行 / 提交中 / 当前页 / 输入值等
 * 运行时状态（不持久化但可绑定）；纯展示型（List）保持从简。
 */
import type { PropertyPaneConfig } from "@shared/types";

import { getMaterial } from "../materials";
import { BaseWidget } from "./base-widget";
import { buildMaterialPropertyPaneConfig } from "./property-pane";

function paneConfigFor(type: string, extraSections: PropertyPaneConfig[] = []): PropertyPaneConfig[] {
  return buildMaterialPropertyPaneConfig(getMaterial(type)?.propSchema ?? [], extraSections);
}

export class TableWidget extends BaseWidget {
  getWidgetType(): string {
    return "Table";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Table");
  }
  getMetaProperties(): Record<string, unknown> {
    return { selectedRowIndex: -1, page: 1 };
  }
}

export class FormWidget extends BaseWidget {
  getWidgetType(): string {
    return "Form";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Form");
  }
  getMetaProperties(): Record<string, unknown> {
    return { isSubmitting: false };
  }
}

export class ListWidget extends BaseWidget {
  getWidgetType(): string {
    return "List";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("List");
  }
}

export class PaginationWidget extends BaseWidget {
  getWidgetType(): string {
    return "Pagination";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Pagination");
  }
  getMetaProperties(): Record<string, unknown> {
    return { current: 1 };
  }
}

export class SearchBarWidget extends BaseWidget {
  getWidgetType(): string {
    return "SearchBar";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("SearchBar");
  }
  getDefaultProperties(): Record<string, unknown> {
    return { value: "" };
  }
  getMetaProperties(): Record<string, unknown> {
    return { value: "", isFocused: false };
  }
}

export class FilterPanelWidget extends BaseWidget {
  getWidgetType(): string {
    return "FilterPanel";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("FilterPanel");
  }
  getMetaProperties(): Record<string, unknown> {
    return { values: {} };
  }
}
